module.exports = __webpack_public_path__ + "img/translationeditor_7.30373545.jpg";